export default {
  supportedLngs: ['en', 'tr', 'ar', 'fr', 'pt', 'it'],
  fallbackLng: 'en',
  debug: true,
  ns: ['common'],
  defaultNS: 'common',
  fallbackNS: 'common',
  loadPath: '/locales/{{lng}}/{{ns}}.json',
  nonExplicitSupportedLngs: true,
  keySeparator: '.',
};
